import React from "react";
import { Navigate } from "react-router-dom";
import { isAuthenticated } from "utils/authUtils";

// This component wraps protected routes and redirects to login if not authenticated
const ProtectedRoute = ({ children }) => {
  // Check if the user is authenticated
  if (!isAuthenticated()) {
    // Redirect to the login page if not authenticated
    return <Navigate to="/signin" replace />;
  }

  // Render the protected component if authenticated
  return children;
};

export default ProtectedRoute;